/* eslint-disable @typescript-eslint/consistent-type-assertions */

import type { PropertyValueResource } from "../../../client/resources/index";
const isBound = (value: PropertyValueResource, fallback = true) => {
    if (value) {
        return (value as string).includes("#{");
    }
    return fallback;
};

export default isBound;
